'use strict';

var util = require('./util');
var buildOptions = require('./util').buildOptions;
var xmlNode = require('./xmlNode');
var toNumber = require("strnum");
var regx = '<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)'.replace(/NAME/g, util.nameRegexp);

//const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
//const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");

//polyfill
if (!Number.parseInt && window.parseInt) {
  Number.parseInt = window.parseInt;
}
if (!Number.parseFloat && window.parseFloat) {
  Number.parseFloat = window.parseFloat;
}
var defaultOptions = {
  attributeNamePrefix: '@_',
  attrNodeName: false,
  textNodeName: '#text',
  ignoreAttributes: true,
  ignoreNameSpace: false,
  allowBooleanAttributes: false,
  //a tag can have attributes without any value
  //ignoreRootElement : false,
  parseNodeValue: true,
  parseAttributeValue: false,
  arrayMode: false,
  trimValues: true,
  //Trim string values of tag and attributes
  cdataTagName: false,
  cdataPositionChar: '\\c',
  numParseOptions: {
    hex: true,
    leadingZeros: true
  },
  tagValueProcessor: function tagValueProcessor(a, tagName) {
    return a;
  },
  attrValueProcessor: function attrValueProcessor(a, attrName) {
    return a;
  },
  stopNodes: [],
  alwaysCreateTextNode: false
  //decodeStrict: false,
};

exports.defaultOptions = defaultOptions;
var props = ['attributeNamePrefix', 'attrNodeName', 'textNodeName', 'ignoreAttributes', 'ignoreNameSpace', 'allowBooleanAttributes', 'parseNodeValue', 'parseAttributeValue', 'arrayMode', 'trimValues', 'cdataTagName', 'cdataPositionChar', 'tagValueProcessor', 'attrValueProcessor', 'parseTrueNumberOnly', 'numParseOptions', 'stopNodes', 'alwaysCreateTextNode'];
exports.props = props;

/**
 * Trim -> valueProcessor -> parse value
 * @param {string} tagName
 * @param {string} val
 * @param {object} options
 */
function processTagValue(tagName, val, options) {
  if (val) {
    if (options.trimValues) {
      val = val.trim();
    }
    val = options.tagValueProcessor(val, tagName);
    val = parseValue(val, options.parseNodeValue, options.numParseOptions);
  }
  return val;
}
function resolveNameSpace(tagname, options) {
  if (options.ignoreNameSpace) {
    var tags = tagname.split(':');
    var prefix = tagname.charAt(0) === '/' ? '/' : '';
    if (tags[0] === 'xmlns') {
      return '';
    }
    if (tags.length === 2) {
      tagname = prefix + tags[1];
    }
  }
  return tagname;
}
function parseValue(val, shouldParse, options) {
  if (shouldParse && typeof val === 'string') {
    //console.log(options)
    var newval = val.trim();
    if (newval === 'true') return true;else if (newval === 'false') return false;else return toNumber(val, options);
  } else {
    if (util.isExist(val)) {
      return val;
    } else {
      return '';
    }
  }
}

//TODO: change regex to capture NS
//const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
var attrsRegx = new RegExp('([^\\s=]+)\\s*(=\\s*([\'"])(.*?)\\3)?', 'g');
function buildAttributesMap(attrStr, options) {
  if (!options.ignoreAttributes && typeof attrStr === 'string') {
    attrStr = attrStr.replace(/\r?\n/g, ' ');
    //attrStr = attrStr || attrStr.trim();

    var matches = util.getAllMatches(attrStr, attrsRegx);
    var len = matches.length; //don't make it inline
    var attrs = {};
    for (var i = 0; i < len; i++) {
      var attrName = resolveNameSpace(matches[i][1], options);
      if (attrName.length) {
        if (matches[i][4] !== undefined) {
          if (options.trimValues) {
            matches[i][4] = matches[i][4].trim();
          }
          matches[i][4] = options.attrValueProcessor(matches[i][4], attrName);
          attrs[options.attributeNamePrefix + attrName] = parseValue(matches[i][4], options.parseAttributeValue, options.numParseOptions);
        } else if (options.allowBooleanAttributes) {
          attrs[options.attributeNamePrefix + attrName] = true;
        }
      }
    }
    if (!Object.keys(attrs).length) {
      return;
    }
    if (options.attrNodeName) {
      var attrCollection = {};
      attrCollection[options.attrNodeName] = attrs;
      return attrCollection;
    }
    return attrs;
  }
}
var getTraversalObj = function getTraversalObj(xmlData, options) {
  xmlData = xmlData.replace(/\r\n?/g, "\n");
  options = buildOptions(options, defaultOptions, props);
  var xmlObj = new xmlNode('!xml');
  var currentNode = xmlObj;
  var textData = "";

  //function match(xmlData){
  for (var i = 0; i < xmlData.length; i++) {
    var ch = xmlData[i];
    if (ch === '<') {
      if (xmlData[i + 1] === '/') {
        //Closing Tag
        var closeIndex = findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.");
        var tagName = xmlData.substring(i + 2, closeIndex).trim();
        if (options.ignoreNameSpace) {
          var colonIndex = tagName.indexOf(":");
          if (colonIndex !== -1) {
            tagName = tagName.substr(colonIndex + 1);
          }
        }

        /* if (currentNode.parent) {
          currentNode.parent.val = util.getValue(currentNode.parent.val) + '' + processTagValue2(tagName, textData , options);
        } */
        if (currentNode) {
          if (currentNode.val) {
            currentNode.val = util.getValue(currentNode.val) + '' + processTagValue(tagName, textData, options);
          } else {
            currentNode.val = processTagValue(tagName, textData, options);
          }
        }
        if (options.stopNodes.length && options.stopNodes.includes(currentNode.tagname)) {
          currentNode.child = [];
          if (currentNode.attrsMap == undefined) {
            currentNode.attrsMap = {};
          }
          currentNode.val = xmlData.substr(currentNode.startIndex + 1, i - currentNode.startIndex - 1);
        }
        currentNode = currentNode.parent;
        textData = "";
        i = closeIndex;
      } else if (xmlData[i + 1] === '?') {
        i = findClosingIndex(xmlData, "?>", i, "Pi Tag is not closed.");
      } else if (xmlData.substr(i + 1, 3) === '!--') {
        i = findClosingIndex(xmlData, "-->", i, "Comment is not closed.");
      } else if (xmlData.substr(i + 1, 2) === '!D') {
        var _closeIndex = findClosingIndex(xmlData, ">", i, "DOCTYPE is not closed.");
        var tagExp = xmlData.substring(i, _closeIndex);
        if (tagExp.indexOf("[") >= 0) {
          i = xmlData.indexOf("]>", i) + 1;
        } else {
          i = _closeIndex;
        }
      } else if (xmlData.substr(i + 1, 2) === '![') {
        var _closeIndex2 = findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;
        var _tagExp = xmlData.substring(i + 9, _closeIndex2);

        //considerations
        //1. CDATA will always have parent node
        //2. A tag with CDATA is not a leaf node so it's value would be string type.
        if (textData) {
          currentNode.val = util.getValue(currentNode.val) + '' + processTagValue(currentNode.tagname, textData, options);
          textData = "";
        }
        if (options.cdataTagName) {
          //add cdata node
          var childNode = new xmlNode(options.cdataTagName, currentNode, _tagExp);
          currentNode.addChild(childNode);
          //for backtracking
          currentNode.val = util.getValue(currentNode.val) + options.cdataPositionChar;
          //add rest value to parent node
          if (_tagExp) {
            childNode.val = _tagExp;
          }
        } else {
          currentNode.val = (currentNode.val || '') + (_tagExp || '');
        }
        i = _closeIndex2 + 2;
      } else {
        //Opening tag
        var result = closingIndexForOpeningTag(xmlData, i + 1);
        var _tagExp2 = result.data;
        var _closeIndex3 = result.index;
        var separatorIndex = _tagExp2.indexOf(" ");
        var _tagName = _tagExp2;
        var shouldBuildAttributesMap = true;
        if (separatorIndex !== -1) {
          _tagName = _tagExp2.substr(0, separatorIndex).replace(/\s\s*$/, '');
          _tagExp2 = _tagExp2.substr(separatorIndex + 1);
        }
        if (options.ignoreNameSpace) {
          var _colonIndex = _tagName.indexOf(":");
          if (_colonIndex !== -1) {
            _tagName = _tagName.substr(_colonIndex + 1);
            shouldBuildAttributesMap = _tagName !== result.data.substr(_colonIndex + 1);
          }
        }

        //save text to parent node
        if (currentNode && textData) {
          if (currentNode.tagname !== '!xml') {
            currentNode.val = util.getValue(currentNode.val) + '' + processTagValue(currentNode.tagname, textData, options);
          }
        }
        if (_tagExp2.length > 0 && _tagExp2.lastIndexOf("/") === _tagExp2.length - 1) {
          //selfClosing tag

          if (_tagName[_tagName.length - 1] === "/") {
            //remove trailing '/'
            _tagName = _tagName.substr(0, _tagName.length - 1);
            _tagExp2 = _tagName;
          } else {
            _tagExp2 = _tagExp2.substr(0, _tagExp2.length - 1);
          }
          var _childNode = new xmlNode(_tagName, currentNode, '');
          if (_tagName !== _tagExp2) {
            _childNode.attrsMap = buildAttributesMap(_tagExp2, options);
          }
          currentNode.addChild(_childNode);
        } else {
          //opening tag

          var _childNode2 = new xmlNode(_tagName, currentNode);
          if (options.stopNodes.length && options.stopNodes.includes(_childNode2.tagname)) {
            _childNode2.startIndex = _closeIndex3;
          }
          if (_tagName !== _tagExp2 && shouldBuildAttributesMap) {
            _childNode2.attrsMap = buildAttributesMap(_tagExp2, options);
          }
          currentNode.addChild(_childNode2);
          currentNode = _childNode2;
        }
        textData = "";
        i = _closeIndex3;
      }
    } else {
      textData += xmlData[i];
    }
  }
  return xmlObj;
};
function closingIndexForOpeningTag(data, i) {
  var attrBoundary;
  var tagExp = "";
  for (var index = i; index < data.length; index++) {
    var ch = data[index];
    if (attrBoundary) {
      if (ch === attrBoundary) attrBoundary = ""; //reset
    } else if (ch === '"' || ch === "'") {
      attrBoundary = ch;
    } else if (ch === '>') {
      return {
        data: tagExp,
        index: index
      };
    } else if (ch === '\t') {
      ch = " ";
    }
    tagExp += ch;
  }
}
function findClosingIndex(xmlData, str, i, errMsg) {
  var closingIndex = xmlData.indexOf(str, i);
  if (closingIndex === -1) {
    throw new Error(errMsg);
  } else {
    return closingIndex + str.length - 1;
  }
}
exports.getTraversalObj = getTraversalObj;